import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IScenario, ScenarioService } from '../scenario-activities/scenario.service';
import { UserSession } from '../shared/user-session';
import { AuthService } from '../authentication/auth.service';
import { UserInfoService } from '../shared/user-info.service';
import {SystemControlElem} from '../shared/system-control-elem';
import { SystemControlService } from '../shared/system-control.service';

@Component({
    //templateUrl: 'app/home/welcome.component.html',
    template: require('./welcome.component.html'),
    styles: [require('../styles/faa_styles.css')]
})
export class WelcomeComponent implements OnInit {
    pageTitle: string = 'Welcome, ' + this.User.getSession()['fullname'];
    currentScenario: IScenario;
    allScenarios: IScenario[];
    errorMessage: string;
    scenarioHeaderDiv: HTMLDivElement;
    isAdmin: boolean;
    isRegionalManager: boolean;
    isScenarioOwner: boolean = false;
    isReadOnly: boolean = false;
    isRegionalReviewPeriod: boolean = false;
    systemControlElem: SystemControlElem;

    constructor(private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService,
                private authService: AuthService,
                private _systemControlService:SystemControlService) { }

    @ViewChild('scenarioHeader') scenarioHeader: ElementRef;

    ngOnInit() {
        //console.log("Welcome ngInit");
        
        this.isAdmin = this.authService.isAdmin();  
        this.isReadOnly = this.authService.isReadOnly();
        this.isRegionalManager = this.authService.isRegionalManager();
        this.User.updateSessionState();
        let tempUserId = this.User.getSession()['id'];
        let tempScenario = this.User.getSession().scenarioId;
        this._scenarioService.getScenarios(tempUserId) 
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    if (this.User.hasValidSession())
                        this.setScenarioHeader(this.User.scenarioId);
                    else {
                        this.setScenarioHeader(this.User.scenarioId);
                        this.User.updateSessionState();
                    }
                }
            );
        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
        
         //this probably needs to be somewhere more central
        this._userInfoService.isScenarioOwner(tempUserId, tempScenario).subscribe(
            success => this.isScenarioOwner = success.isOwner,
            error => this.errorMessage = <any>error
        );

        this._systemControlService.getSystemControl()
            .subscribe(
                systemControlElem => {
                    this.systemControlElem = systemControlElem;
                    this.isRegionalReviewPeriod = this.systemControlElem.isRegionalReviewPeriod;
                },                
                error => this.errorMessage = <any>error
            );
    }

    onScenarioChange(event: Event): void {
        let selectedScenarioId: number = +(event.target as HTMLSelectElement).value;
        this.User.scenarioId = selectedScenarioId;
        this.setScenarioHeader(selectedScenarioId);
        this.User.updateSessionState();
    }

    private setScenarioHeader(scenarioId: number): void {
        let foundScenarios: IScenario[] = this.allScenarios.filter(function (scenario) {
            return scenario.id === scenarioId;
        });
        if (foundScenarios.length > 0) {
            this.currentScenario = foundScenarios[0];
        }
        this.scenarioHeaderDiv.innerHTML = `<strong>Current Scenario: ${this.currentScenario.scenarioName} (${this.currentScenario.id})</strong>`;
    }
}



/** WEBPACK FOOTER **
 ** ./app/home/welcome.component.ts
 **/